export default "__VITE_ASSET__DYn5iufu__"